import { createApp } from '@app/adapters/create-app'
import FollowCompanyToggle from '@app/application/workflows/components/follow-company-toggle.vue'
import { getCurrentUserName, getCurrentUserId } from '@app/adapters/silverfin'
import { Follower } from '../types'

window.onDomLoad(($dom) => {
  const doc = $dom[0]
  const elements = doc.querySelectorAll<HTMLElement>(
    "[data-behaviour='follow-company-toggle']"
  )

  elements.forEach((element) => {
    initializeFollowCompanyToggle(element)
  })
})

function initializeFollowCompanyToggle(element: HTMLElement): void {
  const { insightsEnabled: insightsEnabledData, followers: followersData } =
    element.dataset

  const insightsEnabled = insightsEnabledData === 'true'
  const followers = JSON.parse(followersData || '[]') as Array<Follower>
  const currentUser = {
    id: parseInt(getCurrentUserId() ?? '0'),
    name: getCurrentUserName() ?? '',
  } as Follower

  const followCompanyToggleApp = createApp(FollowCompanyToggle, {
    insightsEnabled,
    followers,
    currentUser,
  })

  followCompanyToggleApp.mount(element)
}
